module.exports = __webpack_public_path__ + "img/a-3gp.17daa6ab.svg";